import React, { useState, useEffect } from 'react';
import { RefreshCcw, MessageSquare, Users, Clock, MessageCircle, Calendar, AlignVerticalSpaceAroundIcon, User, Info } from 'lucide-react';
import { useNotifications } from '@/hooks/useNotifications';
import ChatWidget from '../../common/ChatWidget/ChatWidget';
import StatCard from '@/components/common/StatCard/StatCard';

const ChatAdminPanel = () => {
    const { success, error } = useNotifications();

    const [chats, setChats] = useState([]);
    const [loading, setLoading] = useState(true);
    const [openChats, setOpenChats] = useState([]);
    const [currentChat, setCurrentChat] = useState({ application: 0 });

    const [tramiteRequestId, setTramiteRequestId] = useState(0);
    const [tramiteType, setTramiteType] = useState("");
    const [chatVisible, setChatVisible] = useState(false);

    const REFRESH_INTERVAL = 10_000; // 10 segundos

    useEffect(() => {
        fetchChats();
        const interval = setInterval(fetchChats, REFRESH_INTERVAL);
        return () => clearInterval(interval);
    }, []);

    const fetchChats = async () => {
        try {
            const token = localStorage.getItem('token');
            const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/chat/active`, {
                headers: { "Authorization": `Bearer ${token}` }
            });

            if (!response.ok) return;

            const data = await response.json();
            setChats(data);
            setLoading(false);
        } catch (err) {
            error("Error cargando chats");
        }
    };

    const openChat = (chat) => {
        if (!openChats.find(c => c.id === chat.id)) {
            setOpenChats([...openChats, chat]);
        }
        setCurrentChat(chat);
        setChatVisible(true);
    };

    return (
        <div className="space-y-8">

            {/* Header */}
            <div className="bg-gradient-to-r from-purple-600 to-blue-600 text-white rounded-2xl p-8">
                <div className="flex items-center justify-between">
                    <h1 className="text-3xl font-bold flex items-center gap-3">
                        <MessageSquare /> Panel de Chats
                    </h1>

                    <StatCard
                        title="Chats activos"
                        value={chats.length}
                        icon={<Users />}
                        color="blue"
                    />

                    <button
                        onClick={fetchChats}
                        className="bg-white bg-opacity-20 hover:bg-opacity-30 px-4 py-2 rounded-lg flex items-center gap-2"
                    >
                        <RefreshCcw size={18} /> Actualizar
                    </button>
                </div>
            </div>

            {/* Listado de chats */}
            <div className="bg-white rounded-2xl shadow-lg p-8">
                {chats.length === 0 ? (
                    <div className="text-center py-16 text-gray-500">
                        No hay chats activos por ahora...
                    </div>
                ) : (
                    <div className="space-y-4">
                        {chats.map(chat => (
                            <ChatCard
                                key={chat.id}
                                chat={chat}
                                onOpen={() => openChat(chat)}
                            />
                        ))}
                    </div>
                )}
            </div>

            <div style={{ position: "fixed", right: 5, bottom: 20, maxWidth: 400, zIndex: 999 }}>
                <ChatWidget
                    tramiteRequestId={currentChat.application}
                    isVisible={chatVisible}
                    onToggleVisibility={() => { }}
                    tramiteName={tramiteType?.name} />
            </div>
        </div>
    );
};

const ChatCard = ({ chat, onOpen }) => {
    return (
        <div className="border border-gray-200 rounded-lg p-6 hover:shadow-md transition-shadow bg-gray-50">
            <div className="flex items-center justify-between">
                <div className="flex items-center space-x-4">
                    <MessageSquare className="text-purple-600" size={32} />

                    <div>
                        <h3 className="text-lg font-semibold text-gray-900">
                            Chat con: {chat.user} | Trámite: {chat.application_type}
                        </h3>
                        <p className="text-gray-600 text-sm flex items-center gap-2">
                            <MessageCircle size={14} /> Cantidad de mensajes: {chat.total_messages}
                        </p>
                        <p className="text-gray-600 text-sm flex items-center gap-2">
                            <Calendar size={14} /> Fecha: {chat.date}
                        </p>
                        <p className="text-gray-600 text-sm flex items-center gap-2">
                            <User size={14} /> Gestor: {chat.gestor}
                        </p>
                        <p className="text-gray-600 text-sm flex items-center gap-2">
                            <Info size={14} /> Estado Trámite: {chat.status}
                        </p>
                        <p className="text-gray-600 text-sm flex items-center gap-2">
                            <Clock size={14} /> Último mensaje: {chat.last_activity}
                        </p>
                    </div>
                </div>

                <button
                    onClick={onOpen}
                    className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 flex items-center gap-2"
                >
                    Abrir Chat
                </button>
            </div>
        </div>
    );
};

export default ChatAdminPanel;
